import authenticatedRequest from '../authenticatedRequest';
import querystring from 'query-string';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function createReturn(options) {
    const { baseUrl, brandId, country, returnOrder, uberToken, clientId, clientSecret, email, langId } = options;

    invariant(baseUrl, 'baseUrl is a required param of getOrderHistory()');
    invariant(brandId, 'brandId is a required param of getOrderHistory()');
    invariant(country, 'country is a required param of getOrderHistory()');
    invariant(returnOrder, 'returnOrder is a required param of getOrderHistory()');
    invariant(clientId, 'clientId is a required param of getOrderHistory()');

    const returnPayload = {
        ...returnOrder,
        orderNumber: returnOrder.orderNumber.toUpperCase(),
        returnLines: returnOrder.returnLines.filter((line) => line),
    };

    const queries = email || langId ? `?${querystring.stringify({ email, langId }, { encode: false })}` : '';

    const headers = { 'Content-Type': 'application/json' };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/return${queries}`;
    const request = new Request(url, { headers: new Headers(headers), method: 'POST', body: JSON.stringify(returnPayload) });

    return labelRequest(authenticatedRequest(request, uberToken, clientId, clientSecret), 'createReturn');
}
